import { isPlatformServer } from '@angular/common';
import { Location } from '@freelancer/location';
import { mapTo } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../location/location.service";
import * as i2 from "./login.config";
var AuthCallbackGuard = /** @class */ (function () {
    function AuthCallbackGuard(location, platformId, authService) {
        this.location = location;
        this.platformId = platformId;
        this.authService = authService;
    }
    AuthCallbackGuard.prototype.canActivate = function (route, state) {
        // We render the empty component on the server as we obviously can't set
        // the session there: once returned, the app will bootstrap on the same
        // route, and this guard will be executed again
        if (isPlatformServer(this.platformId)) {
            return true;
        }
        var _a = route.queryParams, uid = _a.uid, token = _a.token, next = _a.next;
        this.authService.setSession(uid, decodeURIComponent(token));
        return this.location
            .navigateByUrl(decodeURIComponent(next))
            .pipe(mapTo(false));
    };
    AuthCallbackGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthCallbackGuard_Factory() { return new AuthCallbackGuard(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i2.LOGIN_AUTH_SERVICE)); }, token: AuthCallbackGuard, providedIn: "root" });
    return AuthCallbackGuard;
}());
export { AuthCallbackGuard };
